import axios from 'axios';
import { DateTime } from 'luxon';

/** North American Numbering Plan: optional leading 1, then NXX-NXX-XXXX (first digit of area/exchange 2–9). */
export function isValidPhoneNANP(value) {
  if (!value || typeof value !== 'string') return false;
  const digits = value.replace(/\D/g, '');
  return /^1?([2-9]\d{2})([2-9]\d{2})(\d{4})$/.test(digits);
}

/** Returns formatted (NXX) NXX-XXXX when digits are valid NANP; otherwise returns the original string. */
export function normalizePhoneNANP(value) {
  if (!value || typeof value !== 'string') return value;
  const digits = value.replace(/\D/g, '');
  const match = digits.match(/^1?([2-9]\d{2})([2-9]\d{2})(\d{4})$/);
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }
  return value;
}

export async function savePatientStoryData({
  formData,
  blobPath,
  specificBlobName,
  userTracking
}) {
  const row = {
    landed_at: DateTime.local().toFormat('yyyy-MM-dd HH:mm:ssZZ'),
    blob_id: specificBlobName,
    FormID: 'azure_app_1',
    form_type: 'patient_story',
    mt_label: 'patient story',
    ...formData,
    ...userTracking
  };

  console.log('row', row);

  const uploadResponse = await axios.post(
    `${import.meta.env.VITE_APP_VENNA_BACKEND_API_BASE_URL}/upload-datalake`,
    {
      formData: row,
      blobPath,
      specificBlobName
    },
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );

  console.log('Upload successful:', uploadResponse.data);
  return uploadResponse.data;
}
